module.exports = __webpack_public_path__ + "img/dine_in.d5eef25d.png";